import {
    CREATE_YARN_INWARD_DETAILS_FAILURE,
    CREATE_YARN_INWARD_DETAILS_REQUEST,
    CREATE_YARN_INWARD_DETAILS_SUCCESS,
    CREATE_USER_FORM_YARN_INWARD_DETAILS,
    DELETE_YARN_INWARD_DETAILS_FAILURE,
    DELETE_YARN_INWARD_DETAILS_REQUEST,
    DELETE_YARN_INWARD_DETAILS_SUCCESS,
    FETCH_SINGLE_YARN_INWARD_DETAILS_FAILURE,
    FETCH_SINGLE_YARN_INWARD_DETAILS_REQUEST,
    FETCH_SINGLE_YARN_INWARD_DETAILS_SUCCESS,
    FETCH_YARN_INWARD_DETAILS_FAILURE,
    FETCH_YARN_INWARD_DETAILS_REQUEST,
    FETCH_YARN_INWARD_DETAILS_SUCCESS,
    YARN_INWARD_DETAILS_USERFORM_RESET,
    UPDATE_YARN_INWARD_DETAILS_FAILURE,
    UPDATE_YARN_INWARD_DETAILS_REQUEST,
    UPDATE_YARN_INWARD_DETAILS_SUCCESS,
    FETCH_YARN_INWARD_DETAILS_BY_ID_REQUEST,
    FETCH_YARN_INWARD_DETAILS_BY_ID_SUCCESS,
    FETCH_PREVIOUS_YARN_INWARD_DETAILS_REQUEST,
    FETCH_PREVIOUS_YARN_INWARD_DETAILS_SUCCESS,
    FETCH_PREVIOUS_YARN_INWARD_DETAILS_FAILURE,
    FETCH_YARN_INWARD_DETAILS_SO_AND_SN_REQUEST,
    FETCH_YARN_INWARD_DETAILS_SO_AND_SN_SUCCESS,
    FETCH_YARN_INWARD_DETAILS_SO_AND_SN_FAILURE,
    YARN_INWARD_DETAILS_PO_DETAILS_DISABLED
} from './yarnInwardDetails.actionsType';

export const YARN_INWARD_DETAILS = 'yarnInwardDetails';

let initialState = {
    loading: false,
    yarnInwardDetailsById: [],
    yarnInwardDetails: [],
    yarnInwardDetailsForm: {
        fldRatePerKG: 0,
        fldQuantity: 0,
        fldGrossValue: 0,
        fldDiscountValue: 0,
        fldIGSTValue: 0,
        fldSGSTValue: 0,
        fldCGSTValue: 0,
        fldNoofBags: 0,
        fldBagWeight: 0,
        fldCGSTPercentage: 0,
        fldIGSTPercentage: 0,
        fldSGSTPercentage: 0,
        fldDiscountPercentage: 0
    },
    previousGetList: [],
    SOAndSNGetList: [],
    selectedYarnInwardDetails: {},
    errorMessage: '',
    iperrorMessage: '',
    isPoDetailsDisabled: false
};

export let yarnInwardDetailsReducer = (state = initialState, action) => {
    let { type, payload, updatePayload } = action;
    switch (type) {
        case FETCH_YARN_INWARD_DETAILS_REQUEST:
        case FETCH_YARN_INWARD_DETAILS_BY_ID_REQUEST:
        case CREATE_YARN_INWARD_DETAILS_REQUEST:
        case FETCH_SINGLE_YARN_INWARD_DETAILS_REQUEST:
        case UPDATE_YARN_INWARD_DETAILS_REQUEST:
        case DELETE_YARN_INWARD_DETAILS_REQUEST:
        case FETCH_PREVIOUS_YARN_INWARD_DETAILS_REQUEST:
        case FETCH_YARN_INWARD_DETAILS_SO_AND_SN_REQUEST:
            return {
                ...state,
                loading: true
            };
        case FETCH_YARN_INWARD_DETAILS_SUCCESS:
            return {
                ...state,
                loading: false,
                yarnInwardDetails: updatePayload
            };
        case FETCH_PREVIOUS_YARN_INWARD_DETAILS_SUCCESS:
            return {
                ...state,
                loading: false,
                previousGetList: updatePayload
            };
        case FETCH_YARN_INWARD_DETAILS_SO_AND_SN_SUCCESS:
            return {
                ...state,
                loading: false,
                SOAndSNGetList: updatePayload
            };
        case FETCH_YARN_INWARD_DETAILS_BY_ID_SUCCESS:
            return {
                ...state,
                loading: false,
                yarnInwardDetailsById: updatePayload
            };

        case CREATE_YARN_INWARD_DETAILS_SUCCESS:
            return {
                ...state,
                loading: false,
                yarnInwardDetailsForm: {
                    fldRatePerKG: 0,
                    fldQuantity: 0,
                    fldGrossValue: 0,
                    fldDiscountValue: 0,
                    fldIGSTValue: 0,
                    fldSGSTValue: 0,
                    fldCGSTValue: 0,
                    fldNoofBags: 0,
                    fldBagWeight: 0,
                    fldCGSTPercentage: 0,
                    fldIGSTPercentage: 0,
                    fldSGSTPercentage: 0,
                    fldDiscountPercentage: 0
                },
                isPoDetailsDisabled: false
            };
        case FETCH_SINGLE_YARN_INWARD_DETAILS_SUCCESS:
            return {
                ...state,
                loading: false,
                selectedYarnInwardDetails: updatePayload,
                yarnInwardDetailsForm: {
                    ...updatePayload
                }
            };
        case UPDATE_YARN_INWARD_DETAILS_SUCCESS:
            return {
                ...state,
                loading: false,
                selectedYarnInwardDetails: {},
                yarnInwardDetailsForm: {
                    fldRatePerKG: 0,
                    fldQuantity: 0,
                    fldGrossValue: 0,
                    fldDiscountValue: 0,
                    fldIGSTValue: 0,
                    fldSGSTValue: 0,
                    fldCGSTValue: 0,
                    fldNoofBags: 0,
                    fldBagWeight: 0,
                    fldCGSTPercentage: 0,
                    fldIGSTPercentage: 0,
                    fldSGSTPercentage: 0,
                    fldDiscountPercentage: 0
                },
                isPoDetailsDisabled: false
            };
        case DELETE_YARN_INWARD_DETAILS_SUCCESS:
            return {
                ...state,
                loading: false,
                yarnInwardDetailsForm: {
                    fldRatePerKG: 0,
                    fldQuantity: 0,
                    fldGrossValue: 0,
                    fldDiscountValue: 0,
                    fldIGSTValue: 0,
                    fldSGSTValue: 0,
                    fldCGSTValue: 0,
                    fldNoofBags: 0,
                    fldBagWeight: 0,
                    fldCGSTPercentage: 0,
                    fldIGSTPercentage: 0,
                    fldSGSTPercentage: 0,
                    fldDiscountPercentage: 0
                },
                selectedYarnInwardDetails: {},
                isPoDetailsDisabled: false
            };

        case FETCH_YARN_INWARD_DETAILS_FAILURE:
        case FETCH_SINGLE_YARN_INWARD_DETAILS_FAILURE:
        case CREATE_YARN_INWARD_DETAILS_FAILURE:
        case UPDATE_YARN_INWARD_DETAILS_FAILURE:
        case DELETE_YARN_INWARD_DETAILS_FAILURE:
        case FETCH_PREVIOUS_YARN_INWARD_DETAILS_FAILURE:
        case FETCH_YARN_INWARD_DETAILS_SO_AND_SN_FAILURE:
            return {
                ...state,
                loading: false,
                errorMessage: updatePayload
            };
        case CREATE_USER_FORM_YARN_INWARD_DETAILS:
            return {
                ...state,
                loading: false,
                yarnInwardDetailsForm: {
                    ...state.yarnInwardDetailsForm,
                    [payload.key]: payload.value
                }
            };
        case YARN_INWARD_DETAILS_PO_DETAILS_DISABLED:
            return {
                ...state,
                isPoDetailsDisabled: payload
            };
        case YARN_INWARD_DETAILS_USERFORM_RESET:
            return {
                ...state,
                yarnInwardDetailsForm: {
                    fldRatePerKG: 0,
                    fldQuantity: 0,
                    fldGrossValue: 0,
                    fldDiscountValue: 0,
                    fldIGSTValue: 0,
                    fldSGSTValue: 0,
                    fldCGSTValue: 0,
                    fldNoofBags: 0,
                    fldBagWeight: 0,
                    fldCGSTPercentage: 0,
                    fldIGSTPercentage: 0,
                    fldSGSTPercentage: 0,
                    fldDiscountPercentage: 0
                },
                selectedYarnInwardDetails: {},
                isPoDetailsDisabled: false
            };
        default:
            return state;
    }
};
